import type { ReactNode } from "react";
import { Alert, type AlertTone } from "../Alert/Alert";
import { Button } from "../Button/Button";

export interface ErrorStateProps {
  readonly title: string;
  readonly message?: string;
  /** Already-localized support reference line, e.g. "Reference: abc123". */
  readonly reference?: string;
  readonly tone?: AlertTone;
  readonly onRetry?: () => void;
  readonly retryLabel?: string;
  /** Extra call-to-action (e.g. an Upgrade link). */
  readonly action?: ReactNode;
  readonly className?: string;
}

/** One error presentation for failed loads: title, explanation, support reference, Retry. */
export function ErrorState({
  title,
  message,
  reference,
  tone = "error",
  onRetry,
  retryLabel,
  action,
  className,
}: ErrorStateProps) {
  const hasActions = Boolean(onRetry) || Boolean(action);
  return (
    <Alert
      tone={tone}
      title={title}
      {...(className ? { className } : {})}
      actions={
        hasActions ? (
          <>
            {action}
            {onRetry ? (
              <Button variant="secondary" size="sm" onClick={onRetry}>
                {retryLabel}
              </Button>
            ) : null}
          </>
        ) : undefined
      }
    >
      {message ? <p>{message}</p> : null}
      {reference ? <p className="text-xs opacity-80">{reference}</p> : null}
    </Alert>
  );
}
